<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >

      <v-flex xs12 sm10 md10 offset-sm1 offset-md1 mb-2>

        <h1 class="text-xs-center display-1"> {{welcomeText.headingText}} </h1>
        <br>
        <p class="text-xs-left subheading font-weight-medium"> {{welcomeText.bodyText}} </p>
        <p class="text-xs-left subheading font-weight-medium">{{welcomeText.contactText}}<a :href="targetEmail" target='_blank'>{{welcomeText.contactEmail}}</a>  </p>
  
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
    }),
    computed: {
      welcomeText: function () {
        return this.$store.getters.getWelcomeText
      },
      targetEmail: function () {
        return "mailto: "+this.welcomeText.contactEmail
      }
    }
  }
</script>

<style scoped>
  p {
    white-space: pre-line;
  }
</style>
